package ru.villawonka.app.presentation.screens.splash.compose

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.koinNavigatorScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import kotlinx.coroutines.flow.filterIsInstance
import org.koin.core.parameter.parametersOf
import ru.villawonka.app.presentation.screens.main.compose.MainScreen
import ru.villawonka.app.presentation.screens.postCard.compose.PostCardScreen
import ru.villawonka.app.presentation.screens.setup.compose.SetupScreen
import ru.villawonka.app.presentation.screens.splash.compose.layout.SplashLoadingStateLayout
import ru.villawonka.app.presentation.screens.splash.viewmodel.SplashUIEvent
import ru.villawonka.app.presentation.screens.splash.viewmodel.SplashUIState
import ru.villawonka.app.presentation.screens.splash.viewmodel.SplashViewModel
import ru.villawonka.app.presentation.sharedviews.DefaultErrorStateLayout

class SplashScreen(private val startParam: String?): Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val viewModel = navigator.koinNavigatorScreenModel<SplashViewModel> { parametersOf(startParam) }
        val state by viewModel.uiState.collectAsStateWithLifecycle(initialValue = SplashUIState.Loading)

        when (state) {
            is SplashUIState.Loading -> SplashLoadingStateLayout()
            is SplashUIState.Error -> DefaultErrorStateLayout(
                failure = (state as SplashUIState.Error).failure,
                onRetryClick = { viewModel.onRetryButtonClick() }
            )
        }

        LaunchedEffect(Unit) {
            viewModel.events.filterIsInstance(SplashUIEvent::class).collect { event ->
                navigator.replaceAll(
                    buildList {
                        when (event) {
                            is SplashUIEvent.OpenSearchScreen ->
                                add(MainScreen(MainScreen.Tab.SEARCH))
                            is SplashUIEvent.OpenPostCardScreen ->
                                addAll(listOf(
                                    MainScreen(MainScreen.Tab.SEARCH),
                                    PostCardScreen(event.postId, event.postType)
                                ))
                        }
                        if (event.isNeedSetupScreenShow) add(SetupScreen())
                    }
                )
            }
        }
    }
}